import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import DatosPersonales from './DatosPersonales'
import IniciarSession from './IniciarSession'

const IndexPersonales = () => {
  const token = localStorage.getItem('token')
  const [seccion, setSeccion] = React.useState(token ? 'datos' : 'login')

  const cerrarSesion = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    window.location.href = '/' // o setSeccion('login') si querés mantenerlo SPA
  }

    // Este efecto se activa solo si hay sesión activa
  useEffect(() => {
    if (seccion === 'datos') {
      const timeout = setTimeout(() => {
        cerrarSesion()
      }, 60 * 60 * 1000) 

      return () => clearTimeout(timeout) // limpia el timeout si se desmonta el componente o cambia la sección
    }
  }, [seccion])


  return (
    <div className='seccion'>
      {seccion === 'login' ? (
        <IniciarSession setSeccion={setSeccion} />
      ) : (
        <>
          <DatosPersonales />
          <div onClick={cerrarSesion} className="btn">Cerrar Sesión</div>
        </>
      )}
    </div>
  )
}

export default IndexPersonales
